import styled from '@emotion/styled';

export const LandingWrapper = styled.div`
  background-color: #00ACF0;
  min-height: 100vh;
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: space-evenly;
`;